<template>
    <div class="content">
        <div class="title"></div>
        <div class="text">
            <p v-for="(items,index) in textList" :key="index">
                {{items}}
            </p>

        </div>

    </div>
</template>

<script>
    export default {
        name: "About",
        data(){
            return{
                textList:[
                    '北京红松在线科技有限公司 公司致力于“为企业战略决策提供专业解决方案”的企业',
                    '始终秉承“客户至上、创新务实、专业专注、诚信规范”的经营理念，',
                    '以客户至上的态度服务客户、以创新务实的精神塑造团队、',
                    '以专业专注的品格开展业务、以诚信规范的准绳经营企业。'
                ]
            }
        }
    }
</script>

<style scoped lang="scss">
    .content{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .title{
            width: 100%;
            height: 73px;
            margin-bottom: 45px;
            background: url("../assets/img/about-us.png") center/contain no-repeat;
        }
        .text{

            line-height: 64px;
            font-size:32px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(51,51,51,1);
            letter-spacing:2px;

        }
    }

</style>